export default {
    setCategoriesinfo(state, payload) {
        state.categories = payload
    },
    setSelectedCategory(state, payload = {}) {
        state.treeSelectedItem = payload
    },
    setSelectedCategoryInCategoryBrowse(state, payload ={}) {
        state.selectedCategoryIdInBrowse = payload;
    },
    setRootCategoryDetails(state, payload ={}){
        state.rootCategoryDetails = payload;
    },
};